import * as types from "../constant";

export function getDataHL(payload) 
{
    return ({
        type: types.GET_DATA_HIGHLIGHT_REQUEST,
        payload
    });
}